<template>
  <svg
    width="160"
    height="171"
    viewBox="0 0 160 171"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M80 140C113.136 140 140 113.189 140 80C140 46.811 113.018 20 80 20C46.8639 20 20 46.811 20 80C20 113.189 46.8639 140 80 140Z"
      fill="url(#paint0_linear_10083_74512)"
    />
    <path
      d="M133.468 109.177C135.885 109.177 137.843 107.219 137.843 104.802C137.843 102.386 135.885 100.428 133.468 100.428C131.052 100.428 129.094 102.386 129.094 104.802C129.094 107.219 131.052 109.177 133.468 109.177Z"
      fill="#C3DFFF"
    />
    <path
      d="M139.871 92.1049C141.521 92.1049 142.859 90.7673 142.859 89.1173C142.859 87.4672 141.521 86.1296 139.871 86.1296C138.221 86.1296 136.883 87.4672 136.883 89.1173C136.883 90.7673 138.221 92.1049 139.871 92.1049Z"
      fill="#C3DFFF"
    />
    <path
      d="M32.7943 46.5661C34.4443 46.5661 35.7819 45.2285 35.7819 43.5784C35.7819 41.9284 34.4443 40.5908 32.7943 40.5908C31.1442 40.5908 29.8066 41.9284 29.8066 43.5784C29.8066 45.2285 31.1442 46.5661 32.7943 46.5661Z"
      fill="#C3DFFF"
    />
    <path
      d="M22.5484 96.1843C25.6128 96.1843 28.0969 93.7002 28.0969 90.6358C28.0969 87.5715 25.6128 85.0874 22.5484 85.0874C19.4841 85.0874 17 87.5715 17 90.6358C17 93.7002 19.4841 96.1843 22.5484 96.1843Z"
      fill="#C3DFFF"
    />
    <g filter="url(#filter0_d_10083_74512)">
      <rect
        x="45.0996"
        y="107.065"
        width="76.9525"
        height="30.8855"
        rx="4"
        fill="url(#paint1_linear_10083_74512)"
      />
    </g>
    <path
      d="M56.0918 118.831H102.126"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M56.0918 126.92H82.8878"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <g filter="url(#filter1_d_10083_74512)">
      <rect
        x="45.0996"
        y="20.1697"
        width="76.9525"
        height="30.8855"
        rx="4"
        fill="url(#paint2_linear_10083_74512)"
      />
    </g>
    <path
      d="M56.0918 31.9355H102.126"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M56.0918 40.0247H82.8878"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <g filter="url(#filter2_d_10083_74512)">
      <rect
        x="36.9434"
        y="58.8767"
        width="91.1445"
        height="40.1831"
        rx="4"
        fill="url(#paint3_linear_10083_74512)"
      />
    </g>
    <path
      opacity="0.6"
      d="M54.3098 85.4017C49.3721 85.4017 45.4219 81.4487 45.4219 76.5074C45.4219 71.5661 49.3721 67.613 54.3098 67.613C59.2476 67.613 63.1978 71.5661 63.1978 76.5074C63.1978 81.3499 59.2476 85.4017 54.3098 85.4017Z"
      fill="url(#paint4_linear_10083_74512)"
    />
    <path
      d="M69.4946 78.9683H115.067"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M69.4946 70.8303H115.067"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M69.4946 87.1062H97.1635"
      stroke="#D9E6F8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <defs>
      <filter
        id="filter0_d_10083_74512"
        x="23.0996"
        y="96.0649"
        width="120.953"
        height="74.8855"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74512"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74512"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74512"
        x="23.0996"
        y="9.16968"
        width="120.953"
        height="74.8855"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74512"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74512"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10083_74512"
        x="14.9434"
        y="47.8767"
        width="135.145"
        height="84.1831"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74512"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74512"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74512"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74512"
        x1="83.5508"
        y1="106.351"
        x2="83.5508"
        y2="138.283"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74512"
        x1="83.5508"
        y1="19.4553"
        x2="83.5508"
        y2="51.3882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74512"
        x1="82.4859"
        y1="57.9472"
        x2="82.4859"
        y2="99.493"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74512"
        x1="45.4216"
        y1="85.4016"
        x2="63.2104"
        y2="67.6256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
